import React from 'react';

const DEFAULT_ERROR_MSG = 'Something went wrong';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: props.errorMessage };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.ignoreMessage) {
        return null;
      }
      // You can render any custom fallback UI
      return <>{this.state.errorMsg || DEFAULT_ERROR_MSG}</>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
